import { createClient } from '@supabase/supabase-js'

const supabaseUrl = 'https://gpusahoipiennaortggo.supabase.co'
const supabaseAnonKey = 'sb_publishable_bvCS0bvzfeG0nCBT4Ex7kg_tszc8Vhd' // حط الـ key الكامل

export const supabase = createClient(supabaseUrl, supabaseAnonKey)